<template>
    <div class="disruptions-table">
        <div class="table-outer-container responsive-table-cards">
            <div class="table-inner-container">
                <table>
                    <thead>
                        <tr>
                            <th>Period</th>
                            <th class="no-sm">
                                Type
                            </th>
                            <th>Disruption</th>
                            <th>TOCs Affected</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="disruption in sortedEntries" :key="disruption.id" :class="isToday(disruption) ? 'today' : ''">
                            <td class="responsive-card-title">
                                <!-- eslint-disable-next-line max-len -->
                                <svg class="disruption-calendar-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path class="fa-primary" d="M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V192H0V112C0 85.49 21.49 64 48 64H96V32zM256 432C256 449.7 241.7 464 224 464C206.3 464 192 449.7 192 432C192 414.3 206.3 400 224 400C241.7 400 256 414.3 256 432zM248 352C248 365.3 237.3 376 224 376C210.7 376 200 365.3 200 352V256C200 242.7 210.7 232 224 232C237.3 232 248 242.7 248 256V352z"></path><path class="fa-secondary" d="M0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM224 400C206.3 400 192 414.3 192 432C192 449.7 206.3 464 224 464C241.7 464 256 449.7 256 432C256 414.3 241.7 400 224 400zM248 256C248 242.7 237.3 232 224 232C210.7 232 200 242.7 200 256V352C200 365.3 210.7 376 224 376C237.3 376 248 365.3 248 352V256z"></path></svg>
                                <div class="encloser">
                                    {{ localeStr(disruption.attributes.startDateLocal) }}
                                    <span
                                        v-if="disruption.attributes.startDateLocal !== disruption.attributes.endDateLocal"
                                    >&ndash; {{ localeStr(disruption.attributes.endDateLocal) }}</span>
                                </div>
                            </td>
                            <td class="no-sm">
                                <p class="table-cell-title disruption-type">
                                    {{ disruption.attributes.type }}
                                </p>
                            </td>
                            <td>
                                <div>
                                    <p class="table-cell-title">
                                        {{ disruption.attributes.description }}
                                    </p>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <p v-if="disruption.attributes.toc" class="toc-scope table-cell-title">
                                        <span class="sm-only">Applies to </span>{{ disruption.attributes.toc }}
                                    </p>
                                    <p v-else class="toc-scope table-cell-title">
                                        All train operators
                                    </p>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="sortedEntries.length === 0" class="no-disruptions">
                            <td colspan="3">
                                <p class="table-cell-title">
                                    There are no upcoming disruptions to travel planned.
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from 'luxon';

export default {
    name: 'DisruptionsTable',
    props: {
        disruptions: {
            type: Array,
            required: true,
        },
    },
    computed: {
        sortedEntries() {
            return [...this.disruptions].sort((a, b) => a.attributes.startDateLocal.localeCompare(b.attributes.startDateLocal))
                .filter((e) => this.isInFuture(e));
        },
    },
    methods: {
        localeStr(date) {
            return DateTime.fromISO(date, { zone: 'Europe/London' })
                .toLocaleString({
                    month: 'long',
                    day: 'numeric',
                    weekday: 'long',
                });
        },
        isInFuture(disruption) {
            const now = DateTime.now().setZone('Europe/London');
            const end = DateTime.fromISO(disruption.attributes.endDateLocal, { zone: 'Europe/London' })
                .set({ hour: 23 })
                .set({ minutes: 59 })
                .set({ seconds: 59 });

            return end >= now;
        },
        isToday(disruption) {
            const now = DateTime.now().setZone('Europe/London');
            const start = DateTime.fromISO(disruption.attributes.startDateLocal, { zone: 'Europe/London' });
            const end = DateTime.fromISO(disruption.attributes.endDateLocal, { zone: 'Europe/London' });
            return start <= now && end >= now;
        },
    },
};
</script>
